module.exports = Promise.resolve(module.bundle.root("5N4SX"))